import { Component, Input } from '@angular/core';
import { GeneralHistoryViewModel } from 'src/app/model/general/history.view';

@Component({
  selector: 'ms-history-item-readonly',
  templateUrl: './history-item-readonly.component.html',
})
export class HistoryItemReadonlyComponent {
  @Input() history: GeneralHistoryViewModel = {};
}
